<!-- page blocker when loading -->
<div attr.role="status" attr.aria-live="polite">
	<div [ngClass]="disable ? 'loader-blocker' : ''">
		<div class="loader-element" [ngClass]="disable ? 'inverse' : ''">
			<div class="loader-graphic">
				<div class="diamond"></div>
				<div class="diamond"></div>
				<div class="diamond"></div>
			</div>
		</div>
	</div>
</div>

